export default {
  classRoomType: {
    id: '',
    capacity: null,
    nameLocal: '',
    nameEng: '',
  },
  classRoomTypes: [],
  processing: false,
  error: null,
  success: null,
}



